<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['系统通知']"/>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="7">
            <span class="search-text">标题：</span>
            <el-input v-model="title" placeholder="请输入标题" class="search-item" clearable size="small"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询</el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              class="flex-1" stripe height="100%"
              style="width: 100%"
              border
          >
            <el-table-column type="index" width="60px" fixed align="center"></el-table-column>
            <el-table-column label="标题" prop="title" align="center">
            </el-table-column>
            <el-table-column label="发布时间" prop="releaseTime" align="center"></el-table-column>
<!--            <el-table-column label="类型" prop="targetType" align="center">-->
<!--            </el-table-column>-->
            <el-table-column width="200" align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button
                    icon="el-icon-document"
                    type="text"
                    size="mini"
                    @click="checkDetail(scope.row.id)"
                >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      title: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let params = {
        title: this.title,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let {data: res} = await this.$http.post(
        '/notice/getPageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    add () {
      this.$router.push('systemNoticeDetail')
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.title = ''
      this.pageSize = 10
      this.currentPage = 1
      this.getPageList()
    },
    checkDetail (id) {
      this.$router.push({
        name: 'SystemNoticeDetail',
        params: {
          id
        }
      })
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/notice/delete', {id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemNotice/index.vue